/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Title_AbandonedInputs */

const en_us2_workout_after_title_abandoned = /** @type {(inputs: Workout_After_Title_AbandonedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session abandoned`)
};

const pt_br2_workout_after_title_abandoned = /** @type {(inputs: Workout_After_Title_AbandonedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessão abandonada`)
};

const es_419_workout_after_title_abandoned = /** @type {(inputs: Workout_After_Title_AbandonedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesión abandonada`)
};

const pt_pt2_workout_after_title_abandoned = /** @type {(inputs: Workout_After_Title_AbandonedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessão abandonada`)
};

const fr_fr2_workout_after_title_abandoned = /** @type {(inputs: Workout_After_Title_AbandonedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séance abandonnée`)
};

const de_de2_workout_after_title_abandoned = /** @type {(inputs: Workout_After_Title_AbandonedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheit abgebrochen`)
};

const it_it2_workout_after_title_abandoned = /** @type {(inputs: Workout_After_Title_AbandonedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessione abbandonata`)
};

/**
* | output |
* | --- |
* | "Session abandoned" |
*
* @param {Workout_After_Title_AbandonedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_title_abandoned = /** @type {((inputs?: Workout_After_Title_AbandonedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Title_AbandonedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_title_abandoned(inputs)
	if (locale === "es-419") return es_419_workout_after_title_abandoned(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_title_abandoned(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_title_abandoned(inputs)
	if (locale === "de-DE") return de_de2_workout_after_title_abandoned(inputs)
	if (locale === "it-IT") return it_it2_workout_after_title_abandoned(inputs)
	return en_us2_workout_after_title_abandoned(inputs)
});
export { workout_after_title_abandoned as "workout-after.title_abandoned" }